import { useQueryClient } from '@tanstack/react-query';

import type { CommonMutationOptions } from '../../../common/types/Common';
import { getHolisticSummaryQueryKey } from './useMembershipHolisticSummary';

// Common mutation options used to trigger a refetch of the membership holistic summary.
export const useRefetchHolisticSummaryMutationOptions = (
    membershipId: string | null,
): CommonMutationOptions => {
    const queryClient = useQueryClient();
    const holisticSummaryQueryKey = getHolisticSummaryQueryKey({
        membershipId,
    });

    return {
        onMutate: async () => {
            await queryClient.cancelQueries({
                queryKey: [holisticSummaryQueryKey],
                exact: true,
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [holisticSummaryQueryKey],
                exact: true,
            });
        },
        onSettled: () => {},
    };
};
